import type { Provider, ProviderDepartment } from "@src/interfaces/provider.interface";

export interface DepartmentOption {
  label: string;
  value: string;
  department: ProviderDepartment;
}

const createVirtualDepartment = (): ProviderDepartment => {
  return {
    department_id: -1,
    clinic_name: "Virtual",
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    zip_code: "",
    department_latitude: 0,
    department_longitude: 0,
  };
};

export function generateDepartmentOptions(details: Provider): DepartmentOption[] {
  const modalities = (details.modality || []).map((modality) => {
    return modality.toLowerCase();
  });
  const onlyVirtual =
    modalities.length > 0 &&
    modalities.every((modality) => {
      return modality.includes("virtual") || modality.includes("telehealth");
    });
  const virtualDepartment = createVirtualDepartment();
  const virtualOption: DepartmentOption = {
    label: "Virtual session",
    value: "virtual",
    department: virtualDepartment,
  };

  if (onlyVirtual) {
    return [virtualOption];
  }

  const options = (details.departments || []).map((department) => {
    return {
      label: `${department.clinic_name}, ${department.address_line_1}, ${department.city}, ${department.state}`,
      value: department.department_id?.toString() || department.clinic_name,
      department,
    };
  });

  const hasVirtual = modalities.some((modality) => {
    return modality.includes("virtual") || modality.includes("telehealth");
  });

  if (hasVirtual) {
    options.push(virtualOption);
  }

  return options;
}
